import {ReactComponent as CartIcon} from 'icons/cart.svg'
import moment from 'moment'
import {useCartPath} from 'providers/EnvironmentProvider'
import {OrderProvider} from 'providers/OrderProvider'

export const Screen = () => {
  const order = OrderProvider.useOrder('optional')
  const cartPath = useCartPath()

  const showCart = () => {
    window.location.href = cartPath
  }

  return (
    <div className="relative cursor-pointer" onClick={showCart}>
      <CartIcon className="text-theme" id="dcw-cart-icon" />
      {order && moment.utc(order.utcExpiresAt).isAfter(moment()) && (
        <div className="rounded-full w-4 h-4 absolute top-[-4px] right-[-4px] text-xs font-medium text-white bg-theme flex justify-center items-center">
          {order.bookings.length}
        </div>
      )}
    </div>
  )
}
